import styled from 'styled-components'

import {ReactComponent as Reverse} from "images/reverse.svg";
import {ReactComponent as Filter} from "images/filter.svg";

export const Page = styled.div`
  height: 100%;
  background-color: white;
  overflow: auto;
`

export const Container = styled(Page)`
  position: relative;
  width: 100%;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;

  @media (min-width: 1200px) {
    max-width: 900px;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .subtitle {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    padding: 1rem;
  }
  .favFilter {
    font-family: 'Lato', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 0.875rem;
    
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    padding: 1rem;
    
    .underlined {
      border-bottom: 3px solid #0139A0;
      height: fit-content;
    }
  }
    
  .filteringBox {
    padding: 0.625rem 0.75rem 0.5rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 3px solid #E0E0E0;
    
    .filterButton {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 4px 10px 6px 10px;
      border: 1px solid #134074;
      border-radius: 4px;
      width: 100%;
      margin: 0 0.25rem;
      color: #134074;
    }
  }
`

export const Icon = styled.img`
  align-self: stretch;
  object-fit: contain;
  margin-right: 3px;
  font-size: 1rem;
  line-height: 1.375rem;
  & path {
    fill: #13CA82;
  }
`;

export const SVG = styled.svg`
  width: ${({width}) => width};
  & path {
    fill: ${({color}) => color};
  }

  &:hover path {
    fill: ${({color}) => color};
  }
`

export const ReverseSVG = styled(Reverse)`
  width: ${({width}) => width};
  & path {
    fill: ${({color}) => color};
  }

  &:hover path {
    fill: ${({color}) => color};
  }
`

export const FilterSVG = styled(Filter)`
  width: ${({width}) => width};
  & path {
    fill: ${({color}) => color};
  }

  &:hover path {
    fill: ${({color}) => color};
  }
`
